import { Controller, useFormContext } from "react-hook-form";
import { ReactComponent as ErrorIcon } from "../icons/exclamation-circle.svg";

function TextAreaField({
  name,
  label,
  subtext,
  callout,
  // "shared" warns that whatever is typed reaches the pet's family; "internal"
  // marks a field they never see.
  calloutVariant = "shared",
  placeholder,
  required,
  requiredText = "This field is required",
  validation,
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const rules = {
    ...(required && { required: requiredText }),
    ...(validation && { validate: validation }),
  };

  return (
    <fieldset>
      <label>
        {label}
        {!required && <span className="label-optional"> (Optional)</span>}
      </label>
      {callout && (
        <p className={`field-callout field-callout-${calloutVariant}`}>
          {calloutVariant === "shared" && (
            <ErrorIcon className="field-callout-icon" aria-hidden="true" />
          )}
          <span>{callout}</span>
        </p>
      )}
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <textarea placeholder={placeholder} {...field} />
        )}
      />
      <span className="input-error">{errors[name]?.message}</span>
      <small>{subtext}</small>
    </fieldset>
  );
}

export default TextAreaField;
